<div class="page-container">
  <div *ngIf="loading" class="loading-state">
    <p>Loading media kit…</p>
  </div>

  <div *ngIf="error" class="error-state">
    <p>{{ error }}</p>
  </div>

  <div *ngIf="!loading && !error" class="media-kit-wrapper">

    <!-- ── Represented-by strip ───────────────────────────────────── -->
    <div class="rep-strip" *ngIf="roster?.isRepresented">
      <span class="rep-label">Represented by</span>
      <span class="rep-badge">VT</span>
      <span class="rep-name">Vertical Talent</span>
    </div>

    <!-- ── Profile card ──────────────────────────────────────────── -->
    <div class="profile-card">
      <div class="profile-left">
        <img class="avatar"
             [src]="roster?.id | profileImage"
             alt="Profile photo"
             onerror="this.style.display='none'" />

        <h1 class="creator-name">{{ roster?.name }}</h1>

        <div class="tag-row">
          <span class="genre-tag" [ngClass]="genreColorClass(tag)" *ngFor="let tag of genreTags">{{ tag }}</span>
        </div>

        <p class="creator-bio" *ngIf="roster?.bioTextLong">{{ roster?.bioTextLong }}</p>

        <div class="meta-row">
          <div class="meta-col" *ngIf="locationDisplay">
            <div class="meta-label">Location</div>
            <div class="meta-value">{{ locationDisplay }}</div>
          </div>
          <div class="meta-col">
            <div class="meta-label">Total Audience</div>
            <div class="meta-value">{{ audienceDisplay }}</div>
          </div>
        </div>

      </div>

      <div class="profile-right" *ngIf="!headerImageError">
        <img class="header-feature-img"
             [src]="headerImageSrc"
             alt=""
             (error)="onHeaderImageError()" />
        <div class="header-img-fade"></div>
      </div>
    </div>

    <!-- ── Demographics carousel ─────────────────────────────────── -->
    <h3 class="brand-partners-title demographics-title">DEMOGRAPHICS</h3>
    <div class="demographics-meta-row">
      <span class="data-timestamp" *ngIf="lastRefreshDisplay">Data as of {{ lastRefreshDisplay }}</span>
      <span class="data-timestamp" *ngIf="!lastRefreshDisplay && !refreshing">Data not yet cached</span>
      <button *ngIf="isLoggedIn" class="refresh-btn" [disabled]="refreshing" (click)="refreshData()">
        <ng-container *ngIf="!refreshing">Refresh Data</ng-container>
        <ng-container *ngIf="refreshing">Refreshing…</ng-container>
      </button>
    </div>
    <span class="refresh-error" *ngIf="refreshError">{{ refreshError }}</span>
    <div class="demo-carousel-outer">

      <!-- Platform tabs -->
      <div class="platform-tabs">

        <button *ngIf="hasPlatform('instagram')"
                class="platform-tab"
                [class.active]="selectedPlatform === 'instagram'"
                (click)="selectPlatform('instagram')">
          <svg class="tab-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
          <span>Instagram</span>
        </button>

        <button *ngIf="hasPlatform('tiktok')"
                class="platform-tab"
                [class.active]="selectedPlatform === 'tiktok'"
                (click)="selectPlatform('tiktok')">
          <svg class="tab-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.19 8.19 0 0 0 4.79 1.52V6.76a4.85 4.85 0 0 1-1.02-.07z"/>
          </svg>
          <span>TikTok</span>
        </button>

        <button *ngIf="hasPlatform('youtube')"
                class="platform-tab"
                [class.active]="selectedPlatform === 'youtube'"
                (click)="selectPlatform('youtube')">
          <svg class="tab-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
          <span>YouTube</span>
        </button>

      </div>
      <div class="demo-carousel-inner"
           [style.transform]="carouselTransform"
           [style.transition]="carouselTransition"
           [style.width]="carouselWidth">

        <div class="demo-slide" *ngFor="let chart of platformCharts" [style.width]="slideWidth">

          <!-- ── Per-platform profile stats ───────────────────── -->
          <div class="platform-stats-row" *ngIf="chart.profile">
            <div class="platform-stat-box">
              <span class="stat-label">Handle</span>
              <span class="stat-value">
                <a *ngIf="getHandleUrl(chart.platform) as url; else plainHandle"
                   [href]="url" target="_blank" rel="noopener noreferrer"
                   class="handle-link">{{ getHandleDisplay(chart.platform) }}</a>
                <ng-template #plainHandle>{{ getHandleDisplay(chart.platform) }}</ng-template>
              </span>
            </div>
            <div class="platform-stat-box">
              <span class="stat-label">{{ chart.profile.followersCountLabel }}</span>
              <span class="stat-value">{{ chart.profile.followersCount }}</span>
            </div>
            <div class="platform-stat-box">
              <span class="stat-label">{{ chart.profile.totalLikesLabel }}</span>
              <span class="stat-value">{{ chart.profile.totalLikes }}</span>
            </div>
            <div class="platform-stat-box">
              <span class="stat-label">{{ chart.profile.postsCountLabel }}</span>
              <span class="stat-value">{{ chart.profile.postsCount }}</span>
            </div>
          </div>

          <p class="demographics-note" *ngIf="chart.demographicsNote">{{ chart.demographicsNote }}</p>

          <div class="audience-grid">

            <!-- Gender -->
            <div class="audience-section">
              <h3 class="audience-title">AUDIENCE GENDER</h3>
              <div class="audience-card">
                <div class="pie-chart" [style.background]="chart.genderChartBackground">
                  <div class="pie-center"><span class="pie-label">Gender</span></div>
                </div>
                <div class="pie-legend" *ngIf="chart.hasGenderData">
                  <div class="legend-item">
                    <span class="legend-swatch" style="background:#f59e0b"></span>
                    <span class="legend-label">Female</span>
                    <span class="legend-value">{{ chart.femaleDisplay }}%</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-swatch" style="background:#2563eb"></span>
                    <span class="legend-label">Male</span>
                    <span class="legend-value">{{ chart.maleDisplay }}%</span>
                  </div>
                  <div class="legend-item" *ngIf="chart.otherDisplay > 0">
                    <span class="legend-swatch" style="background:#6b7280"></span>
                    <span class="legend-label">Other</span>
                    <span class="legend-value">{{ chart.otherDisplay }}%</span>
                  </div>
                </div>
              </div>
              <p class="no-data-msg" *ngIf="!chart.hasGenderData">Not Enough Followers</p>
            </div>

            <!-- Countries -->
            <div class="audience-section">
              <h3 class="audience-title">TOP COUNTRIES</h3>
              <div class="audience-card">
                <div class="pie-chart" [style.background]="chart.countryChartBackground">
                  <div class="pie-center"><span class="pie-label">Countries</span></div>
                </div>
                <div class="pie-legend" *ngIf="chart.hasCountryData">
                  <div class="legend-item" *ngFor="let slice of chart.topCountrySlices">
                    <span class="legend-swatch" [style.background]="slice.color"></span>
                    <span class="legend-label">{{ slice.label }}</span>
                    <span class="legend-value">{{ slice.percent | percent:'1.0-0' }}</span>
                  </div>
                </div>
              </div>
              <p class="no-data-msg" *ngIf="!chart.hasCountryData">Not Enough Followers</p>
            </div>

            <!-- Cities -->
            <div class="audience-section" *ngIf="chart.hasCityData">
              <h3 class="audience-title">TOP CITIES</h3>
              <div class="audience-card">
                <div class="pie-chart" [style.background]="chart.cityChartBackground">
                  <div class="pie-center"><span class="pie-label">Cities</span></div>
                </div>
                <div class="pie-legend">
                  <div class="legend-item" *ngFor="let slice of chart.topCitySlices">
                    <span class="legend-swatch" [style.background]="slice.color"></span>
                    <span class="legend-label">{{ slice.label }}</span>
                    <span class="legend-value">{{ slice.percent | percent:'1.0-0' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ages -->
            <div class="audience-section">
              <h3 class="audience-title">TOP AGES</h3>
              <div class="audience-card">
                <div class="pie-chart" [style.background]="chart.ageChartBackground">
                  <div class="pie-center"><span class="pie-label">Ages</span></div>
                </div>
                <div class="pie-legend" *ngIf="chart.hasAgeData">
                  <div class="legend-item" *ngFor="let slice of chart.ageSlices">
                    <span class="legend-swatch" [style.background]="slice.color"></span>
                    <span class="legend-label">{{ slice.label }}</span>
                    <span class="legend-value">{{ slice.percent | percent:'1.0-0' }}</span>
                  </div>
                </div>
              </div>
              <p class="no-data-msg" *ngIf="!chart.hasAgeData">Not Enough Followers</p>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- ── Top Videos ───────────────────────────────────────────── -->
    <ng-container *ngIf="topVideos.length > 0">
      <h3 class="brand-partners-title demographics-title">TOP VIDEOS</h3>
      <div class="platform-tabs">

        <button *ngIf="hasVideosPlatform('instagram')"
                class="platform-tab"
                [class.active]="selectedVideosPlatform === 'instagram'"
                (click)="selectVideosPlatform('instagram')">
          <svg class="tab-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
          <span>Instagram</span>
        </button>

        <button *ngIf="hasVideosPlatform('tiktok')"
                class="platform-tab"
                [class.active]="selectedVideosPlatform === 'tiktok'"
                (click)="selectVideosPlatform('tiktok')">
          <svg class="tab-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.19 8.19 0 0 0 4.79 1.52V6.76a4.85 4.85 0 0 1-1.02-.07z"/>
          </svg>
          <span>TikTok</span>
        </button>

        <button *ngIf="hasVideosPlatform('youtube')"
                class="platform-tab"
                [class.active]="selectedVideosPlatform === 'youtube'"
                (click)="selectVideosPlatform('youtube')">
          <svg class="tab-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
          <span>YouTube</span>
        </button>

      </div>
      <div class="videos-carousel-outer">
        <div class="videos-carousel-inner"
             [style.transform]="videosCarouselTransform"
             [style.transition]="videosCarouselTransition"
             [style.width]="videosCarouselWidth">
          <div class="video-slide" *ngFor="let vp of videoPlatforms" [style.width]="videosSlideWidth">
            <div class="top-videos-grid">
              <div class="video-card" *ngFor="let video of getVideosForPlatform(vp)">
                <a class="video-thumb-link"
                   [href]="video.shareUrl ?? video.ShareUrl"
                   target="_blank"
                   rel="noopener noreferrer">
                  <ng-container *ngIf="!showThumbFallback(video); else thumbFallback">
                    <img class="video-thumb"
                         [src]="videoThumb(video)"
                         [alt]="video.title ?? video.Title ?? 'video'"
                         (error)="onThumbError(video)" />
                    <div class="video-play-btn">
                      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                  </ng-container>
                  <ng-template #thumbFallback>
                    <div class="video-thumb-placeholder">
                      <svg class="video-thumb-placeholder-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
                      </svg>
                    </div>
                  </ng-template>
                </a>
                <div class="video-stats">
                  <span class="video-stat">
                    <svg class="video-stat-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                    {{ formatViews(video.views ?? video.Views ?? 0) }}
                  </span>
                  <span class="video-stat">
                    <svg class="video-stat-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5 2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35z"/></svg>
                    {{ formatViews(video.likes ?? video.Likes ?? 0) }}
                  </span>
                  <span class="video-stat">
                    <svg class="video-stat-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>
                    {{ formatViews(video.comments ?? video.Comments ?? 0) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ── Brand Partners ───────────────────────────────────────── -->
    <h3 class="brand-partners-title demographics-title" *ngIf="pastPartnershipsList.length > 0">BRAND PARTNERS</h3>
    <div class="brand-partners-section" *ngIf="pastPartnershipsList.length > 0">
      <div class="brand-logos-container">
        <a *ngFor="let domain of pastPartnershipsList"
           [href]="'https://' + domain"
           target="_blank"
           rel="noopener noreferrer">
          <img [src]="brandLogoUrl(domain)"
               [alt]="domain + ' logo'"
               class="brand-logo" />
        </a>
      </div>
    </div>

  </div>
</div>
